// extracted by mini-css-extract-plugin
export var formContainer = "_lb-0";
export var message = "_lb-1";